import React, { useState } from 'react';
import { FaShareAlt, FaLink, FaTwitter, FaLinkedin, FaWhatsapp } from 'react-icons/fa';

export default function ShareButtons({ url, title, text }) {
  const [copied, setCopied] = useState(false);

  const doShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title, text, url });
        return;
      }
    } catch (_) {
      // fallthrough to copy
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (_) {
      alert('Copy the link: ' + url);
    }
  };

  const encoded = encodeURIComponent(url);
  const shareText = encodeURIComponent(text || title || 'Check this out');

  const links = {
    twitter: `https://twitter.com/intent/tweet?url=${encoded}&text=${shareText}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encoded}&title=${shareText}`,
    whatsapp: `https://api.whatsapp.com/send?text=${shareText}%20${encoded}`,
  };

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={doShare}
        className="flex items-center gap-2 px-3 py-2 rounded-md bg-white/10 text-white hover:bg-white/20 border border-white/20"
        aria-label="Share"
      >
        <FaShareAlt />
        <span>{copied ? 'Copied!' : 'Share'}</span>
      </button>
      <a
        href={links.twitter}
        target="_blank"
        rel="noopener noreferrer"
        className="px-3 py-2 rounded-md bg-white/10 text-white hover:bg-white/20 border border-white/20"
        aria-label="Share on Twitter"
      >
        <FaTwitter />
      </a>
      <a
        href={links.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        className="px-3 py-2 rounded-md bg-white/10 text-white hover:bg-white/20 border border-white/20"
        aria-label="Share on LinkedIn"
      >
        <FaLinkedin />
      </a>
      <a
        href={links.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className="px-3 py-2 rounded-md bg-white/10 text-white hover:bg-white/20 border border-white/20"
        aria-label="Share on WhatsApp"
      >
        <FaWhatsapp />
      </a>
      <button
        type="button"
        onClick={() => doShare()}
        className="px-3 py-2 rounded-md bg-white/10 text-white hover:bg-white/20 border border-white/20"
        aria-label="Copy Link"
        title="Copy Link"
      >
        <FaLink />
      </button>
    </div>
  );
}
